import { render, staticRenderFns } from "./CreateCustomerGroup.vue?vue&type=template&id=507c4194"
import script from "./CreateCustomerGroup.vue?vue&type=script&lang=js"
export * from "./CreateCustomerGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports